// src/components/ui/Card.jsx
import React from 'react';

export function Card({
  title,
  children,
  className = '',
  bodyClassName = '',
  style,
  ...rest
}) {
  return (
    <section
      className={`card bg-white shadow-sm rounded-lg p-4 ${className}`.trim()}
      style={style}
      {...rest}
    >
      {title && <h3 className="text-xl font-semibold mb-2">{title}</h3>}
      <div className={`space-y-2 ${bodyClassName}`.trim()}>{children}</div>
    </section>
  );
}
